<template>
  <component :is="Comp" @resetTable="resetTable" ref="operationManageParent">
    <el-tabs tab-position="top" type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="students">
        <span slot="label" >Danh sách học sinh</span>
        <DataManageStudentPackages @resetDataFilter="resetDataFilter" ref="dataManageStudentPackages" tab="class"/>
      </el-tab-pane>
      <el-tab-pane name="packages">
        <span slot="label">Danh sách gói</span>
        <DataManagePackages tab="group"/>
      </el-tab-pane>
    </el-tabs>
  </component>
</template>

<script>
import OperationManageStudents from "@/components/FinanceVer2/managePackages/components/OperationManageStudents.vue";
import OperationManagePackages from "@/components/FinanceVer2/managePackages/components/OperationManagePackages.vue";
import DataManageStudentPackages from "@/components/FinanceVer2/managePackages/components/DataManageStudentPackages.vue";
import DataManagePackages from "@/components/FinanceVer2/managePackages/components/DataManagePackages.vue";

export default {
  components: {
    DataManageStudentPackages,
    DataManagePackages,
  },
  data() {
    return {
      activeName: "students",
      Comp: OperationManageStudents,
    }
  },
  methods: {
    handleClick(tab) {
      switch (tab.name) {
        case "students":
          this.Comp = OperationManageStudents;
          break;
        case "packages":
          this.Comp = OperationManagePackages;
          break;
      }
    },

    resetTable() {
      this.$refs.dataManageStudentPackages.resetSelection();
    },

    resetDataFilter() {
      this.$refs.operationManageParent.resetDataFilter();
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-tabs__item {
    background-color: #abaca8;
    color: #fff !important;
  }

  /deep/.el-tabs__item.is-active {
    background-color: #78a5e7;
    color: #fff !important;
  }

  /deep/.el-tabs__header {
    display: flex;
    justify-content: flex-end; /* Đẩy tab sang phải */
  }

  /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item {
    border: none;
  }

  /deep/.el-tabs--card>.el-tabs__header {
    margin-bottom: 0;
    border-bottom: none;
  }

  /deep/.el-tabs__nav-wrap {
    border-bottom: 1px solid #DCDFE6;
  }
</style>